export default __webpack_public_path__ + "static/our-solutions-50d329ee3ab7d92ccf234068af0ce8db.webp";